import { useEffect } from 'react';

import { applyChurchBrand, clearChurchBrand } from '@/lib/brand-colors';
import { useChurchStore } from '@/stores/church-store';
import { useTheme } from '@/stores/theme-store';

/** Writes the active church's brand tokens onto `:root` for the console shell. */
export const useChurchBrand = (): void => {
  const church = useChurchStore((state) => state.church);
  const resolved = useTheme((state) => state.resolved);

  useEffect(() => {
    if (!church) {
      clearChurchBrand();
      return;
    }

    applyChurchBrand(
      { brandPrimary: church.brandPrimary, brandAccent: church.brandAccent },
      resolved,
    );
  }, [church?.brandPrimary, church?.brandAccent, church?.id, resolved]);
};
